import { Mail, Phone, MapPin, Facebook } from "lucide-react";

const Footer = () => {
  return (
    <footer className="bg-blue-700 text-white pt-16 pb-8 border-t border-blue-800">
      <div className="container-custom">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          {/* Brand */}
          <div className="space-y-6">
            <div className="flex items-center">
              <img 
                src="/6f4dcea8-90c6-4c14-95d1-820165e65591-removebg-preview.png" 
                alt="Hj 3Ddesign Logo" 
                className="h-24 md:h-32 w-auto object-contain brightness-0 invert" 
              />
            </div>
            <p className="text-blue-100 max-w-xs leading-relaxed">
              Kreative, unikke og funktionelle 3D-printede designs til både hverdag og gavebrug.
            </p>
          </div>

          {/* Contact */}
          <div className="space-y-6">
            <h3 className="font-bold text-xl tracking-tight">Kontakt</h3>
            <ul className="space-y-4">
              <li className="flex items-center gap-3 text-blue-50">
                <MapPin size={18} className="text-blue-300" />
                <span>Jagtvej 82, 6705 Esbjerg</span>
              </li>
              <li className="flex items-center gap-3 text-blue-50">
                <Phone size={18} className="text-blue-300 shrink-0" />
                <div className="flex flex-wrap items-center gap-x-2">
                  <a href="tel:+4581980952" className="hover:text-blue-200 transition-colors">+45 81 98 09 52</a>
                  <span className="text-blue-300">/</span>
                  <a href="tel:+4581951952" className="hover:text-blue-200 transition-colors">+45 81 95 19 52</a>
                </div>
              </li>
              <li className="flex items-center gap-3 text-blue-50">
                <Mail size={18} className="text-blue-300" />
                <a href="mailto:hj3ddesign@outlook.dk" className="hover:text-blue-200 transition-colors">hj3ddesign@outlook.dk</a>
              </li>
              <li className="flex items-center gap-3 text-blue-50">
                <span className="text-xs font-bold text-blue-300 tracking-wider">CVR</span>
                <span>46368274</span>
              </li>
            </ul>
          </div>

          {/* Socials */}
          <div className="space-y-6">
            <h3 className="font-bold text-xl tracking-tight">Følg os</h3>
            <div className="flex gap-4">
              <a 
                href="https://www.facebook.com/p/HJ3DDesign-61582796377764/" 
                target="_blank" 
                rel="noopener noreferrer" 
                aria-label="Følg HJ3DDesign på Facebook" 
                className="w-12 h-12 bg-blue-800 border border-blue-600 rounded-full flex items-center justify-center text-white hover:bg-white hover:text-blue-700 transition-all shadow-sm"
              >
                <Facebook size={22} />
              </a>
            </div>
          </div>
        </div>
        
        <div className="pt-8 border-t border-blue-800 text-center text-blue-300 text-sm">
          <p>© {new Date().getFullYear()} Hj3ddesign. Alle rettigheder forbeholdes. CVR: 46368274</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
